import { render, staticRenderFns } from "./ContractRiskManage.vue?vue&type=template&id=2f3780c1&scoped=true&"
import script from "./ContractRiskManage.vue?vue&type=script&lang=js&"
export * from "./ContractRiskManage.vue?vue&type=script&lang=js&"
import style0 from "./ContractRiskManage.vue?vue&type=style&index=0&id=2f3780c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3780c1",
  null
  
)

export default component.exports